<template>
  <div class="teacher">
    <div class="teacher-top">
      <!-- 搜索框 -->
      <div class="teacher-search">
        <search :placeholder="placeholder" @search="search" />
      </div>
      <!-- <div class="teacher-count-container">
        <span class="teacher-count-narration">
          当前教师数量：
          <span class="teacher-count">{{ total }}</span>
        </span>
      </div> -->
      <div class="teacher-operation-part-container">
        <button class="button add" @click="addTeacherDialogShow" v-hasPermi="'sc:teacher:add'">
          <i class="iconfont icon-addStudent"></i>添加教师
        </button>
        <!-- 下载模板 -->
        <button class="button download" @click="uploadXlsxModule" v-hasPermi="'sc:teacher:add'">
          <i class="iconfont icon-download"></i>下载模板
        </button>
        <!-- 批量删除 -->
        <button class="button delete" @click="deleteClick" v-hasPermi="'sc:teacher:delete'">
          <i class="iconfont icon-delete" />批量删除
        </button>
      </div>
    </div>
    <!-- 教师列表 -->
    <teacherList class="teacher-list" :teacherList="teacherList" v-bitmap="getTeacherListResult"
      @multipleDelete="multipleDelete" />
    <!-- 分页 -->
    <div class="teacher-pagination">
      <pagination :total="parseInt(total)" :pageSize="parseInt(pageSize)" @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange" />
    </div>
    <!-- 添加教师的dialog -->
    <teacherAddDialog :isAddTeacherDialogShow.sync="isAddTeacherDialogShow" v-show="isAddTeacherDialogShow"
      @uploadFailList="uploadFailList" />
    <!-- 上传失败信息的dialog -->
    <teacherUploadFailList :isUploadFailShow.sync="isUploadFailShow" v-show="isUploadFailShow"
      :uploadFail="uploadFail" />
  </div>
</template>

<script>
import teacherList from "./components/teacher-list/teacher-list.vue";
import pagination from "@/components/pagination/pagination";
import teacherAddDialog from "./components/teacher-add-dialog/teacher-add-dialog.vue";
import teacherUploadFailList from "./components/teacher-upload-fail-list/teacher-upload-fail-list.vue";
import search from "@/components/search/search.vue";

import { baseURL } from "@/api/request.js";

export default {
  name: "",
  data() {
    return {
      getTeacherListResult: "nullData",
      isAddTeacherDialogShow: false,
      // 分页参数
      total: 0, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页条数
      teacherList: [], // 教师列表
      deleteList: [], // 教师批量删除列表
      // 上传失败的工号和电话
      uploadFail: {
        number: [],
        phone: [],
      },
      isUploadFailShow: false,
      placeholder: "请输入教师名称",
      queryName: "",
    };
  },
  components: {
    teacherList,
    pagination,
    teacherAddDialog,
    teacherUploadFailList,
    search,
  },
  provide() {
    return {
      refresh: this.refresh,
    };
  },
  created() {
    // 获取班级考试信息列表
    this.getTeacherList();
  },
  methods: {
    // 刷新
    refresh() {
      // this.pageNum = 1;
      // this.total = 0;
      this.teacherList = [];
      this.getTeacherList();
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getTeacherList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTeacherList();
    },
    // 获取教师列表
    getTeacherList() {
      // this.getTeacherListResult = "loading";
      this.post(this.$url.selectTeacherListByAdminPC, {
        schoolId: this.user.schoolId,
        teacherName: this.queryName,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      })
        .then((res) => {
          // console.log(res);
          if (res.code != 200) {
            this.getTeacherListResult = "error";
            this.$message.error("获取教师列表失败！");
            return;
          }
          let data = res;
          this.total = data.total;
          this.total > 0
            ? (this.getTeacherListResult = "success")
            : (this.getTeacherListResult = "nullData");
          this.teacherList = data.rows;
          this.loading = false;
        })
        .catch((err) => {
          this.getTeacherListResult = "error";
          this.$message.error("获取教师列表失败，请稍后再试");
        });
    },

    // 显示添加教师弹出框
    addTeacherDialogShow() {
      this.isAddTeacherDialogShow = true;
    },
    // 下载模板
    uploadXlsxModule() {
      window.open(`${baseURL}${this.$url.downloadTeacherExcel}`);
      // window.location.href = baseURL + this.$url.downloadTeacherExcel + encodeURI(fileName) + "&delete=" + true;
    },
    multipleDelete(res) {
      this.deleteList = res;
    },
    // 批量删除
    deleteClick() {
      if (!this.deleteList.length) {
        return this.$message.warning("请先选择需要删除的教师");
      }
      this.$confirm("是否删除选中的教师?", "删除教师", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // console.log("this.deleteList=>", this.deleteList);
          // 调用删除接口
          this.post(this.$url.deleteTeacher, this.deleteList)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error("删除失败");
              }
            })
            .catch((err) => {
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => { });
    },
    // 上传表格时有上传失败的工号或电话
    uploadFailList(option) {
      this.uploadFail = option;
      this.isUploadFailShow = true;
    },
    search(query) {
      this.queryName = query;
      // 刷新
      this.refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./teacher.scss";
</style>
